import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { AdmFilterPointEx } from "../../api/models/adm-filter-point-ex";
import { AdmFilterKeyOption } from "../../api/models/adm-filter-key-option";
import { AdmTableColumn } from "../../api/models/adm-table-column";
import { DialogResult, DialogResultType } from "../DialogResult";
import { FILTER_TYPES, COMPARISON_OPERATORS } from "../../modules/admin/controls/admin-adm-definition/admin-adm-definition.component";

export interface AdmFilterPointDialogData {
  filterPoint: AdmFilterPointEx;
  physicalColumns: AdmTableColumn[];
  columnLabel: (id: number) => string;
  // The selectable "Filter key" values - sourced from the backend (AdmFilterValues.AllKeys via GetDefinition's
  // availableFilterKeys), not hardcoded here, since a key only exists once the server-side mapping supports it.
  filterKeys: AdmFilterKeyOption[];
}

// Admin ADM Definition > Filter Points > one named request-level filter and which columns it applies to.
@Component({
  selector: "adm-filter-point-dialog",
  templateUrl: "./adm-filter-point-dialog.component.html",
})
export class AdmFilterPointDialogComponent {
  public result: AdmFilterPointEx;
  public Result: DialogResult = { ResultType: DialogResultType.Cancel, ResultData: null };
  public filterTypes = FILTER_TYPES;
  public comparisonOperators = COMPARISON_OPERATORS;

  constructor(public dialogRef: MatDialogRef<AdmFilterPointDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: AdmFilterPointDialogData) {
    this.result = { ...data.filterPoint, targetColumnIds: [...(data.filterPoint.targetColumnIds || [])] };
  }

  get isNew(): boolean {
    return !this.data.filterPoint.admFilterPointId;
  }

  // Comparison's definitionJson is just {"operator": "..."} - a dropdown over the same whitelist the server
  // enforces (AdmDefinitionValidator.ComparisonOperators), instead of hand-typed JSON prone to typos or an
  // unsupported operator.
  get comparisonOperator(): string {
    try {
      return JSON.parse(this.result.definitionJson || "{}").operator || "";
    } catch {
      return "";
    }
  }

  set comparisonOperator(value: string) {
    this.result.definitionJson = JSON.stringify({ operator: value });
  }

  columnLabel(id: number): string {
    return this.data.columnLabel(id);
  }

  onSave(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.result;
    this.dialogRef.close(this.Result);
  }

  onToggleRetired(): void {
    this.Result.ResultType = DialogResultType.Delete;
    this.Result.ResultData = this.result;
    this.dialogRef.close(this.Result);
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  static showDialog(dialog: MatDialog, data: AdmFilterPointDialogData): Observable<DialogResult> {
    return dialog.open(AdmFilterPointDialogComponent, { disableClose: false, width: "800px", data }).afterClosed();
  }
}
